import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from './footer';

class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.bottomFooter}>
                <Footer content={content} />
            </div>
        );
    }
}

export default errorBoundary(BottomFooter);
